import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {Location} from "@angular/common";
import {
  SS_CHECKOUT_ENDPOINT,
  SS_COUPONS_RELEASE_ENDPOINT,
  SS_COUPONS_VALIDATE_ENDPOINT,
  SS_FIDELITY_EVALUATION_ENDPOINT,
  SS_POS_ACTION_ENDPOINT,
  SS_PRINT_ENDPOINT
} from "../../features/stockstore-pos/stockstore-pos.types";
import {OrderPhasesNavigationService} from "../services/order-phases-navigation.service";

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {

  /**
   * List of application paths where this interceptor should not operate.
   * Note: Allow us to go in the configurator page, otherwise we would not be able to correct wrong data.
   * As the application loads the configuration when being created and for example a 404 can be returned.
   * @private
   */
  private readonly excludedPaths = ['/configurator'];
  /**
   * List of api endpoints where this interceptor should not operate
   * @private
   */
  private readonly excludedUrls = [SS_CHECKOUT_ENDPOINT,
    SS_PRINT_ENDPOINT,
    SS_FIDELITY_EVALUATION_ENDPOINT,
    SS_POS_ACTION_ENDPOINT,
    SS_COUPONS_RELEASE_ENDPOINT,
    SS_COUPONS_VALIDATE_ENDPOINT];

  constructor(private navService: OrderPhasesNavigationService,
              private location: Location) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError(error => {

        const isExcludedEndpoint = this.excludedUrls.some(url => request.url.includes(url));
        const isExcludedPath = this.excludedPaths.includes(this.location.path());


        if (!isExcludedPath && !isExcludedEndpoint)
          return this.handleResponseError(error);
        else
          return throwError(() => error);
      })
    );
  }

  private handleResponseError(error: any) {
    if (error.status == 0)
      this.navService.navigateToErrorPhase('network');
    else
      this.navService.navigateToErrorPhase(error.status);

    return throwError(() => error);
  }
}
